import { Inspection, Step } from 'escapod';

const totalEstimatedTime = (total: number, step: Inspection | Step): number =>
  total + step.estimatedTime;

export default totalEstimatedTime;
